<template>
  <div class="logistics-status-layout">
    <Header :pageTitle="list[0].status" />
    <div class="content">
      <div class="content-item">
        <div class="tracking-number">
          <div id="tracking-number">{{ name }} {{ number }}</div>
          <div class="copy" @click="toCopy">复制</div>
        </div>
        <van-steps
          v-if="list && list.length"
          active-color="#FF3D3D"
          direction="vertical"
          :active="0"
        >
          <van-step v-for="(item, index) in list" :key="index">
            <div class="time-line">
              <div class="status" :style="{color: index === 0 ? '#FF3D3D !important': '#333333'}">{{ item.status }}</div>
              <div class="time">{{ item.time }}</div>
            </div>
            <p
              v-html="highLightMobile(item.context)"
              style="color: #666666; font-size: 13px; line-height: 20px;"
            ></p>
          </van-step>
        </van-steps>
        <div class="no-logistics-status" v-else>
          <img
            width="80px"
            src="@/assets/img/mobileImg/searchNone.png"
            alt=""
          />
          <div class="text">暂无物流信息</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/mobileView/components/header/index.vue";
import { Toast } from "vant";
export default {
  components: {
    Header,
  },
  data() {
    return {
      number: "",
      name: "",
      list: [],
    };
  },
  created() {
    let obj = JSON.parse(sessionStorage.getItem("logisticsStatus"));
    console.log("obj", obj);
    this.number = obj.number;
    this.name = obj.name;
    this.list = obj.list;
  },
  methods: {
    // 复制快递单号
    toCopy() {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", this.number);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        Toast("复制成功");
      }
      document.body.removeChild(input);
    },
    // 电话号码高亮显示
    highLightMobile(str) {
      let regx = /(\d{11}|\d{3}-\d{8}|\d{4}-\d{8})/g;
      let phoneNums = str.match(regx);
      if (phoneNums != null && phoneNums.length) {
        phoneNums = Array.from(new Set(phoneNums));
      }
      if (phoneNums) {
        for (var i = 0; i < phoneNums.length; i++) {
          var temp = phoneNums[i];
          str = str.replace(
            new RegExp(phoneNums[i], "g"),
            `<a href="tel:${temp}" style="color: #397bf9;">${temp}</a>`
          );
        }
      }
      return str;
    },
  },
};
</script>
<style lang="scss">
html,
body {
  height: 100%;
  background: #f5f5f5;
}
.logistics-status-layout {
  padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
  padding-top: calc(env(safe-area-inset-top) + 44px) !important;
  .content {
    padding: 0 12px 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .content-item {
      width: calc(100% - 1px);
      background: white;
      border: 1px solid white;
      border-radius: 13px;
      padding: 0 16px;
      background: white;
      margin-top: 12px;
      .tracking-number {
        display: flex;
        justify-content: space-between;
        padding: 12px;
        color: #333333;
        font-weight: bold;
        .copy {
          cursor: pointer;
          font-weight: normal;
        }
      }
      .no-logistics-status {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 50px 0;
        .text {
          margin-top: 20px;
        }
      }
    }
    .time-line {
      display: flex;
      .status {
        color: #333333;
        font-size: 15px;
        font-weight: bold;
      }
      .time {
        margin-left: 14px;
        margin-bottom: 12px;
        color: #999999;;
      }
    }
  }
}
</style>